import prettyBytes from 'pretty-bytes';

export default function (size, locale = 'en') {
    return prettyBytes(size, { locale });
}
